import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelected] = useState(() => localStorage.getItem("storeig_selected_store") || "all");
  const [loading, setLoading] = useState(true);

  const loadStores = async () => {
    const r = await api.get("/stores");
    setStores(r.data);
    return r.data;
  };

  useEffect(() => { loadStores().finally(() => setLoading(false)); }, []);

  const setSelectedStore = (id) => {
    setSelected(id);
    localStorage.setItem("storeig_selected_store", id);
  };

  const currentStore = stores.find((s) => s.id === selectedStore) || null;

  return (
    <StoreContext.Provider value={{ stores, selectedStore, setSelectedStore, currentStore, loading, loadStores }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
